export type BusinessRole = "owner" | "staff";

export type PermissionKey =
  | "dashboard"
  | "invoices"
  | "scan"
  | "suppliers"
  | "supplier_merge"
  | "par_level"
  | "par_check"
  | "par_template"
  | "reports"
  | "integrations"
  | "team"
  | "business_settings"
  | "owner_summary";

export const STAFF_DEFAULT_PERMISSIONS: Record<PermissionKey, boolean> = {
  dashboard: true,
  invoices: true,
  scan: true,
  suppliers: true,
  supplier_merge: false,
  par_level: true,
  par_check: true,
  par_template: true,
  reports: true,
  integrations: false,
  team: false,
  business_settings: false,
  owner_summary: false,
};

export const BUSINESS_ROLES: BusinessRole[] = ["staff", "owner"];

export function permissionAllowed(
  role: string | null | undefined,
  permission: string,
  explicitPermissions: Record<string, boolean> = {},
): boolean {
  if (role === "owner") return true;
  if (role !== "staff") return false;
  if (permission === "par_level") {
    return permissionAllowed(role, "par_check", explicitPermissions)
      || permissionAllowed(role, "par_template", explicitPermissions);
  }
  if (Object.prototype.hasOwnProperty.call(explicitPermissions, permission)) {
    return explicitPermissions[permission] !== false;
  }
  if (
    (permission === "par_check" || permission === "par_template")
    && Object.prototype.hasOwnProperty.call(explicitPermissions, "par_level")
  ) {
    return explicitPermissions.par_level !== false;
  }
  return STAFF_DEFAULT_PERMISSIONS[permission as PermissionKey] === true;
}
